import { useState, useEffect } from "react";
import { AppBar, Toolbar, IconButton, TextField } from "@mui/material";
import { Modal, ListItemText, ListItemIcon, ListItem } from "@mui/material";
import { List, Drawer, Divider, Dialog } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import PublicIcon from "@mui/icons-material/Public";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import ContactsIcon from "@mui/icons-material/Contacts";
import WorkIcon from "@mui/icons-material/Work";
import { createGlobalStyle } from "styled-components";
import { UpdateMetaThemeColour } from "./Utils/UpdateMetaThemeColour";
import logosml from "./images/ITS_LOGO_BLACK_SML.svg";
import { returnBackgroundColour } from "./Utils/returnBackgroundColour";
import { useHistory, useLocation } from "react-router-dom";
import LoginIcon from "@mui/icons-material/Login";
import PersonIcon from "@mui/icons-material/Person";

import ViewKanbanIcon from "@mui/icons-material/ViewKanban";
import SearchIcon from "@mui/icons-material/Search";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
// import EventDataModal from "./Calendar/EventDataModal";
import CloseIcon from "@mui/icons-material/Close";

import { db, doc, updateDoc } from "./firebaseConfig";

import { useAtom } from "jotai";
import { isIdleAtom, currentStaffDataAtom, isElectronAtom } from "./-Atoms";
import { publish } from "./GlobalFunctions/customEvent";

import DockFunctions from "./GlobalFunctions/DockFunctions";

import QRScanner from "./GlobalComponents/QRScanner";

import TrafficLight from "./macos-traffic-light";

import UserMenu from "./UserMenu";
import SearchModalV2 from "./GlobalComponents/SearchModalV2";
import EventDataModalV2 from "./Calendar/EventDataModalV2";

const { DateTime } = require("luxon");

const drawerWidth = 220;
const appBarHeight = 64;

const GlobalStyles = createGlobalStyle`
  .initialSearchButton {
    min-width: 180px;
    min-height: 34px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0px;
    padding-left: 4.8px;
    position: relative;
    color: rgb(176, 184, 196);
    font-size: 0.9rem;
    cursor: pointer;
    transition-property: all;
    transition-duration: 150ms;
    border-radius: 10px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    background-color: ${({ theme }) =>
      theme === "dark" ? "rgba(0, 0, 0, 0.2)" : "rgba(0, 0, 0, 0.1)"};
  }
  .initialSearchButton:hover {
    border: 1px solid rgba(0, 0, 0, 0.2);
    background-color: ${({ theme }) =>
      theme === "dark" ? "rgba(50, 50, 50, 0.2)" : "rgba(50, 50, 50, 0.1)"};
  }
`;

const menuItems = [
  {
    text: "Calendar",
    icon: <CalendarTodayIcon />,
    path: "/calendar",
    isRoot: true,
  },
  {
    text: "Kanban",
    icon: <ViewKanbanIcon />,
    path: "/kanban",
    isRoot: true,
  },
  {
    text: "Clients",
    icon: <ContactsIcon />,
    path: "/clients",
    admin: true,
  },
  {
    text: "Staff",
    icon: <PersonIcon />,
    path: "/staff",
  },
  // {
  //   text: "Styling",
  //   icon: <CheckroomIcon />,
  //   path: "/styling",
  // },
  {
    text: "Outsourcers",
    icon: <PublicIcon />,
    path: "/outsourcers",
    admin: true,
  },
  {
    text: "Jobs",
    icon: <WorkIcon />,
    path: "/jobs",
    admin: true,
  },

  {
    text: "Admin Tools",
    icon: <SupervisedUserCircleIcon />,
    path: "/admin",
    admin: true,
  },
];

const Layout = ({
  children,
  user,
  auth,
  userTheme,
  handleThemeChange,
  theme,
}) => {
  const { showDock, hideDock } = DockFunctions();
  UpdateMetaThemeColour({
    light: returnBackgroundColour("light"),
    dark: returnBackgroundColour("dark"),
  });

  const [currentStaffData] = useAtom(currentStaffDataAtom);

  const history = useHistory();
  const location = useLocation();

  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const signOut = () => {
    if (window?.electron?.logoutFirebase) {
      window?.electron?.logoutFirebase();
      setTimeout(() => {
        auth.signOut();
      }, 2000);
    } else {
      auth.signOut();
    }

    handleMenuClose();
    // window?.ipcRenderer?.send("sendSwiftLogout");
  };

  const [notificationSettingsMenuAnchor, setNotificationSettingsMenuAnchor] =
    useState(null);

  const handleNotificationSettingsClick = (event) => {
    setNotificationSettingsMenuAnchor(event.currentTarget);
  };

  const handleNotificationSettingsClose = () => {
    setNotificationSettingsMenuAnchor(null);
  };

  // const isIdle = true;
  const [isIdle] = useAtom(isIdleAtom);

  const [searchModalOpen, setSearchModalOpen] = useState(false);
  const handleSearchModalOpen = () => {
    setSearchModalOpen(true);
    hideDock();
  };
  const handleSearchModalClose = () => {
    setSearchModalOpen(false);
    showDock();
  };

  const [searchResultModalOpen, setSearchResultModalOpen] = useState(false);

  // EventDataModalV2 state for search results
  const [eventDataModalOpen, setEventDataModalOpen] = useState(false);
  const [eventDataModalData, setEventDataModalData] = useState(null);
  const [eventDataModalClientOnly, setEventDataModalClientOnly] =
    useState(false);
  // eslint-disable-next-line no-unused-vars
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  // eslint-disable-next-line no-unused-vars

  const handleEventDataModalOpen = (data, clientOnly = false) => {
    setEventDataModalData(data);
    setEventDataModalClientOnly(clientOnly);
    setEventDataModalOpen(true);
  };

  const handleEventDataModalClose = () => {
    setEventDataModalOpen(false);
    setEventDataModalData(null);
    setEventDataModalClientOnly(false);
    setHasUnsavedChanges(false);
    // Don't close search modal - keep it open behind
  };

  // console.log(setSearchModal);

  useEffect(() => {
    const listener = (e) => {
      if (
        (e.code === "KeyK" || e.code === "KeyF") &&
        (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey)
      ) {
        e.preventDefault();
        setSearchModalOpen((prev) => {
          const newValue = !prev;
          if (newValue) {
            hideDock();
          } else {
            showDock();
          }

          return newValue;
        });
      }
    };
    document.addEventListener("keydown", listener, false);
    return () => {
      document.removeEventListener("keydown", listener, false);
    };
  }, [hideDock, showDock]);

  const isMobile = useMediaQuery("@media (max-width:780px)");
  const isDesktop = useMediaQuery("@media (min-width:1000px)");

  const calendarPrevious = () => {
    publish("calendarPrevious");
  };
  const calendarNext = () => {
    publish("calendarNext");
  };

  const [detailsFilledCorrectly, setDetailsFilledCorrectly] = useState(true);
  const [detailsFilled, setDetailsFilled] = useState({});

  useEffect(() => {
    const main = () => {
      if (user?.staffData?.firstName) {
        checkIfDetailsFilledCorrectly(user.staffData);
      }
    };
    main();
  }, [user]);

  const checkIfDetailsFilledCorrectly = (userData) => {
    // console.log(userData);
    let detailsFilledCorrectlyTmp = true;
    let detailsFilledTmp = {
      firstName: true,
      lastName: true,
      phoneNumber: true,
      dateOfBirth: true,
      streetNumber: true,
      streetName: true,
      postcode: true,
      suburb: true,
      employmentBasis: true,
      nextOfKin1Name: true,
      nextOfKin1Phone: true,
      taxFileNumber: true,
      bankName: true,
      BSB: true,
      superannuationProvider: true,
      superannuationMemberNumber: true,
      superannuationFundUSI: true,
    };
    if (!userData.firstName) {
      detailsFilledCorrectlyTmp = false;
      detailsFilledTmp.firstName = false;
    }
    if (!userData.lastName) {
      detailsFilledCorrectlyTmp = false;
      detailsFilledTmp.lastName = false;
    }
    if (!userData.phoneNumber) {
      detailsFilledCorrectlyTmp = false;
      detailsFilledTmp.phoneNumber = false;
    }
    if (!userData.dateOfBirth) {
      detailsFilledCorrectlyTmp = false;
      detailsFilledTmp.dateOfBirth = false;
    }
    if (!userData.address?.streetNumber) {
      detailsFilledCorrectlyTmp = false;
      detailsFilledTmp.streetNumber = false;
    }
    if (!userData.address?.streetName) {
      detailsFilledCorrectlyTmp = false;
      detailsFilledTmp.streetName = false;
    }
    if (!userData.address?.postcode) {
      detailsFilledCorrectlyTmp = false;
      detailsFilledTmp.postcode = false;
    }
    if (!userData.address?.suburb) {
      detailsFilledCorrectlyTmp = false;
      detailsFilledTmp.suburb = false;
    }
    if (!userData.employmentBasis) {
      detailsFilledCorrectlyTmp = false;
      detailsFilledTmp.employmentBasis = false;
    }
    if (!userData.nextOfKin1Name) {
      detailsFilledCorrectlyTmp = false;
      detailsFilledTmp.nextOfKin1Name = false;
    }
    if (!userData.nextOfKin1Phone) {
      detailsFilledCorrectlyTmp = false;
      detailsFilledTmp.nextOfKin1Phone = false;
    }
    if (!userData.taxFileNumber) {
      detailsFilledCorrectlyTmp = false;
      detailsFilledTmp.taxFileNumber = false;
    }
    if (!userData.bankName) {
      detailsFilledCorrectlyTmp = false;
      detailsFilledTmp.bankName = false;
    }
    if (!userData.BSB) {
      detailsFilledCorrectlyTmp = false;
      detailsFilledTmp.BSB = false;
    }
    if (!userData.superannuationProvider) {
      detailsFilledCorrectlyTmp = false;
      detailsFilledTmp.superannuationProvider = false;
    }
    if (!userData.superannuationMemberNumber) {
      detailsFilledCorrectlyTmp = false;
      detailsFilledTmp.superannuationMemberNumber = false;
    }
    if (!userData.superannuationFundUSI) {
      detailsFilledCorrectlyTmp = false;
      detailsFilledTmp.superannuationFundUSI = false;
    }
    const checkAgain = localStorage.getItem("checkDetailedFilledAgain");
    let checkAgainDate = DateTime.fromISO(
      checkAgain
        ? checkAgain
        : DateTime.now().setZone("Australia/Sydney").startOf("day")
    );
    const now = DateTime.now().setZone("Australia/Sydney");
    if (now > checkAgainDate) {
      // console.lo;
      setDetailsFilledCorrectly(detailsFilledCorrectlyTmp);
    } else {
      setDetailsFilledCorrectly(true);
    }
    setDetailsFilled(detailsFilledTmp);
  };

  const [qrDialogOpen, setQrDialogOpen] = useState(false);
  const handleQrDialogClose = () => {
    setQrDialogOpen(false);
    showDock();
  };
  // const generateLoginToken = firebase
  //   .functions()
  //   .httpsCallable("generateLoginToken");
  const [isElectron] = useAtom(isElectronAtom);

  return (
    <>
      <GlobalStyles theme={theme} />
      <FillOutDetailsModal
        detailsFilledCorrectly={detailsFilledCorrectly}
        setDetailsFilledCorrectly={setDetailsFilledCorrectly}
        detailsFilled={detailsFilled}
        theme={theme}
        user={user}
      />
      <SearchModalV2
        searchModalOpen={searchModalOpen}
        handleSearchModalClose={handleSearchModalClose}
        handleEventDataModalOpen={handleEventDataModalOpen}
        eventDataModalOpen={eventDataModalOpen}
        isDesktop={isDesktop}
        handleEventDataModalClose={handleEventDataModalClose}
      />
      {/* EventDataModalV2 - Conditional rendering based on desktop vs mobile */}
      {searchModalOpen && eventDataModalOpen ? (
        // Desktop side-by-side layout - no modal wrapper needed
        <div
          style={{
            position: "fixed",
            top: "calc(40px)", // Adjusted position to match search modal visually
            right: "12vw", // Adjusted to maintain 8vw margin with 50vw width
            width: "50vw", // Event modal width
            height: "calc(100vh - 84px)", // Match search modal exactly
            background:
              theme === "dark" ? "rgb(28, 28, 28)" : "rgb(250, 250, 250)",
            zIndex: 1400, // Same level as search modal
            overflowY: "auto",
            borderRadius: "0px 10px 10px 0px",
            boxShadow: "0px 3px 10px rgba(0, 0, 0, 0.2)",
          }}
        >
          <EventDataModalV2
            initialJobData={eventDataModalData}
            eventDataModalOpen={eventDataModalOpen}
            setEventDataModalOpen={setEventDataModalOpen}
            clientOnlyMode={eventDataModalClientOnly}
            isEventTomorrow={isEventTomorrow}
            confirmationStatusEmailOpen={false}
            setConfirmationStatusEmailOpen={() => {}}
            firstConfirmationStatusEmailOpen={false}
            setFirstConfirmationStatusEmailOpen={() => {}}
            setConfirmationEmailData={() => {}}
          />
        </div>
      ) : (
        // Mobile/tablet/non-side-by-side modal layout
        eventDataModalOpen && <></>
      )}
      <QRScannerDialog
        open={qrDialogOpen}
        handleClose={handleQrDialogClose}
        // generateLoginToken={generateLoginToken}
      />

      <AppBar
        elevation={0}
        style={{
          position: "fixed",
          backgroundColor: `#${returnBackgroundColour(theme)}`,
          transition: "margin-left 225ms cubic-bezier(0, 0, 0.2, 1) 0ms",
          minHeight: `${isElectron ? appBarHeight + 10 : appBarHeight}px`,
          borderBottom: `1px solid ${
            theme === "dark" ? "rgb(40, 40, 40)" : "rgb(240, 240, 240)"
          }`,
        }}
        position="static"
        sx={{ zIndex: 200, top: isElectron ? 10 : "" }}
      >
        <Toolbar
          sx={{
            zIndex: 99,
            WebkitAppRegion: "no-drag !important",
            appRegion: "no-drag !important",
          }}
        >
          {isElectron ? (
            <div style={{ position: "absolute", top: 10, left: 10 }}>
              <TrafficLight
                onClose={() => {
                  window.ipcRenderer.send("customCloseWindow");
                }}
                onMinimize={() => {
                  window.ipcRenderer.send("customMinimizeWindow");
                }}
                onMaximize={() => {
                  window.ipcRenderer.send("customMaximizeWindow");
                }}
              />
            </div>
          ) : null}
          <ButtonGroup
            variant="outlined"
            sx={{
              WebkitAppRegion: "no-drag !important",
              appRegion: "no-drag !important",
              display: isMobile
                ? window.innerWidth < 320
                  ? "none"
                  : "block"
                : "none",
              marginLeft: isElectron ? 7 : 1,
            }}
          >
            <Button
              sx={{
                WebkitAppRegion: "no-drag !important",
                appRegion: "no-drag !important",
                borderColor:
                  theme === "dark"
                    ? "rgba(210, 210, 210, 0.2)"
                    : "rgba(40, 40, 40, 0.2)",
              }}
              onClick={calendarPrevious}
            >
              <NavigateBeforeIcon
                sx={{ color: theme === "dark" ? "#ffffff" : "#4d4d4d" }}
              />
            </Button>
            <Button
              sx={{
                WebkitAppRegion: "no-drag !important",
                appRegion: "no-drag !important",
                borderColor:
                  theme === "dark"
                    ? "rgba(210, 210, 210, 0.2)"
                    : "rgba(40, 40, 40, 0.2)",
              }}
              onClick={calendarNext}
            >
              <NavigateNextIcon
                sx={{ color: theme === "dark" ? "#ffffff" : "#4d4d4d" }}
              />
            </Button>
          </ButtonGroup>
          {/* Desktop Search Bar */}
          {!isMobile && (
            <div
              style={{
                display: "flex",
                position: "absolute",
                right: user ? (isIdle ? 125 : isElectron ? 125 : 100) : 10,
                paddingRight: 25,
              }}
            >
              <button
                className="initialSearchButton"
                onClick={handleSearchModalOpen}
                style={{
                  outline: "none",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    outline: "none",
                    color: theme === "dark" ? "" : "#4d4d4d",
                    WebkitAppRegion: "no-drag !important",
                    appRegion: "no-drag !important",
                  }}
                >
                  <SearchIcon sx={{ marginRight: 1, marginLeft: 1 }} />
                  Search...
                </div>
                <div
                  style={{
                    fontSize: "0.75rem",
                    fontWeight: 700,
                    marginLeft: 4,
                    border: "1px solid rgba(0, 0, 0, 0.3)",
                    backgroundColor:
                      theme === "dark"
                        ? "rgba(0, 0, 0, 0.2)"
                        : "rgba(0, 0, 0, 0.1)",
                    padding: 4,
                    borderRadius: 7,
                    color: theme === "dark" ? "#ffffff" : "#4d4d4d",
                  }}
                >
                  ⌘F
                </div>
              </button>
            </div>
          )}

          <div
            style={{ position: "absolute", right: "0", paddingRight: "25px" }}
          >
            {user ? (
              <UserMenu
                user={user}
                so={signOut}
                a={anchorEl}
                click={handleMenuClick}
                close={handleMenuClose}
                notificationSettingsMenuAnchor={notificationSettingsMenuAnchor}
                handleNotificationSettingsClose={
                  handleNotificationSettingsClose
                }
                handleNotificationSettingsClick={
                  handleNotificationSettingsClick
                }
                userTheme={userTheme}
                handleThemeChange={handleThemeChange}
                theme={theme}
                setQrDialogOpen={setQrDialogOpen}
                handleSearchModalOpen={handleSearchModalOpen}
                isMobile={isMobile}
              />
            ) : (
              <IconButton
                onClick={() => {
                  window.location.href = "/calendar";
                }}
              >
                <LoginIcon
                  sx={{ color: theme === "dark" ? "#ffffff" : "#4d4d4d" }}
                />
              </IconButton>
            )}
          </div>
        </Toolbar>
      </AppBar>
      <div
        style={{
          WebkitAppRegion: searchResultModalOpen
            ? "no-drag !important"
            : "drag",
          appRegion: searchResultModalOpen ? "no-drag !important" : "drag",
          position: "absolute",
          width: "100vw",
          height: 24,
          // height: appBarHeight,
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1,
          pointerEvents: "none",
        }}
      />

      <div style={{ display: "flex" }}>
        <Drawer
          sx={{ width: drawerWidth }}
          open={open}
          onClose={() => {
            setOpen(false);
          }}
          anhcor="left"
          disableScrollLock={true}
          classes={{ paper: { width: drawerWidth } }}
        >
          <div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={logosml}
                alt="Logo"
                style={{
                  width: "40%",
                  paddingTop: "20px",
                  paddingBottom: "40px",
                }}
              />
            </div>
            <List>
              {menuItems.map((item) =>
                item.admin ? (
                  isAdmin(currentStaffData) ? (
                    <CreateListItem
                      key={item.text}
                      item={item}
                      history={history}
                      location={location}
                      setOpen={setOpen}
                    />
                  ) : null
                ) : (
                  <CreateListItem
                    key={item.text}
                    item={item}
                    history={history}
                    location={location}
                    setOpen={setOpen}
                  />
                )
              )}
            </List>
          </div>
        </Drawer>
        <div
          style={{
            padding: 0,
            marginTop: `${isElectron ? appBarHeight + 12 : appBarHeight}px`,
          }}
        >
          {children}
        </div>
      </div>
    </>
  );
};

export default Layout;

const FillOutDetailsModal = ({
  detailsFilledCorrectly,
  setDetailsFilledCorrectly,
  detailsFilled,
  theme,
  user,
}) => {
  const modalContainerStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "85vw",
    height: "75vh",
    backgroundColor: theme === "dark" ? "#1f1f1f" : "#ffffff",
    boxShadow: `rgba(20, 20, 20, ${
      theme === "dark" ? "0.7" : "0.2"
    }) 0px 4px 20px`,
    border: `1px solid rgb(${
      theme === "dark" ? "50, 50, 50" : "200, 200, 200"
    })`,
    borderRadius: "4px",
    outline: "none",
    overflow: "hidden",
    zIndex: 9999,
    padding: 20,
  };
  const textFieldStyle = { margin: 10 };
  const [detailsFilledDateOfBirth, setDetailsFilledDateOfBirth] =
    useState(null);
  return (
    <>
      <Modal
        open={!detailsFilledCorrectly}
        onClose={() => {
          setDetailsFilledCorrectly(true);
          const checkAgain = DateTime.now()
            .setZone("Australia/Sydney")
            .startOf("day")
            .plus({ days: 2 });
          localStorage.setItem("checkDetailedFilledAgain", checkAgain);
        }}
        sx={{
          "& > .MuiBackdrop-root": {
            backdropFilter: "blur(4px)",
          },
        }}
      >
        <div style={modalContainerStyle}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <span>Some of your details have not been filled out</span>
            <span style={{ marginBottom: 10 }}>
              Please fill out the following information:
            </span>
            {!detailsFilled.firstName ? (
              <TextField
                variant="outlined"
                label="First Name"
                id="detailsFilled_firstName"
                fullWidth
                style={textFieldStyle}
              />
            ) : null}
            {!detailsFilled.lastName ? (
              <TextField
                variant="outlined"
                label="Last Name"
                id="detailsFilled_lastName"
                fullWidth
                style={textFieldStyle}
              />
            ) : null}
            {!detailsFilled.phoneNumber ? (
              <TextField
                variant="outlined"
                label="Phone Number"
                id="detailsFilled_phoneNumber"
                fullWidth
                style={textFieldStyle}
              />
            ) : null}
            {!detailsFilled.dateOfBirth ? (
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <MobileDatePicker
                  label="Date of Birth"
                  format="dd/MM/yyyy"
                  value={detailsFilledDateOfBirth}
                  onChange={(e) => {
                    setDetailsFilledDateOfBirth(new Date(e));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      fullWidth
                      style={textFieldStyle}
                    />
                  )}
                />
              </LocalizationProvider>
            ) : null}
            {!detailsFilled.streetNumber ? (
              <TextField
                variant="outlined"
                label="Street Number"
                id="detailsFilled_streetNumber"
                fullWidth
                style={textFieldStyle}
              />
            ) : null}
            {!detailsFilled.streetName ? (
              <TextField
                variant="outlined"
                label="Street Name"
                id="detailsFilled_streetName"
                fullWidth
                style={textFieldStyle}
              />
            ) : null}
            {!detailsFilled.postcode ? (
              <TextField
                variant="outlined"
                label="Postcode"
                id="detailsFilled_postcode"
                fullWidth
                style={textFieldStyle}
              />
            ) : null}
            {!detailsFilled.suburb ? (
              <TextField
                variant="outlined"
                label="Suburb"
                id="detailsFilled_suburb"
                fullWidth
                style={textFieldStyle}
              />
            ) : null}
            {!detailsFilled.nextOfKin1Name ? (
              <TextField
                variant="outlined"
                label="Next Of Kin 1 Name"
                id="detailsFilled_nextOfKin1Name"
                fullWidth
                style={textFieldStyle}
              />
            ) : null}
            {!detailsFilled.nextOfKin1Phone ? (
              <TextField
                variant="outlined"
                label="Next Of Kin 1 Phone"
                id="detailsFilled_nextOfKin1Phone"
                fullWidth
                style={textFieldStyle}
              />
            ) : null}
            {!detailsFilled.taxFileNumber ? (
              <TextField
                variant="outlined"
                label="Tax File Number"
                id="detailsFilled_taxFileNumber"
                fullWidth
                style={textFieldStyle}
              />
            ) : null}
            {!detailsFilled.bankName ? (
              <TextField
                variant="outlined"
                label="Bank Name"
                id="detailsFilled_bankName"
                fullWidth
                style={textFieldStyle}
              />
            ) : null}
            {!detailsFilled.BSB ? (
              <TextField
                variant="outlined"
                label="BSB"
                id="detailsFilled_BSB"
                fullWidth
                style={textFieldStyle}
              />
            ) : null}
            {!detailsFilled.superannuationProvider ? (
              <TextField
                variant="outlined"
                label="Superannuation Provider"
                id="detailsFilled_superannuationProvider"
                fullWidth
                style={textFieldStyle}
              />
            ) : null}
            {!detailsFilled.superannuationMemberNumber ? (
              <TextField
                variant="outlined"
                label="Superannuation Member Number"
                id="detailsFilled_superannuationMemberNumber"
                fullWidth
                style={textFieldStyle}
              />
            ) : null}
            {!detailsFilled.superannuationFundUSI ? (
              <TextField
                variant="outlined"
                label="Superannuation Fund USI"
                id="detailsFilled_superannuationFundUSI"
                fullWidth
                style={textFieldStyle}
              />
            ) : null}
          </div>
          <Button
            variant="contained"
            sx={{
              position: "absolute",
              bottom: 15,
              left: "calc(85vw / 2 - 34px)",
            }}
            onClick={async () => {
              let tmp = {};
              if (!detailsFilled.firstName) {
                const val = document.getElementById(
                  "detailsFilled_firstName"
                ).value;
                if (val) tmp.firstName = val;
              }
              if (!detailsFilled.lastName) {
                const val = document.getElementById(
                  "detailsFilled_lastName"
                ).value;
                if (val) tmp.lastName = val;
              }
              if (!detailsFilled.phoneNumber) {
                const val = document.getElementById(
                  "detailsFilled_phoneNumber"
                ).value;
                if (val) tmp.phoneNumber = val;
              }
              if (!detailsFilled.dateOfBirth) {
                tmp.dateOfBirth = detailsFilledDateOfBirth;
              }
              if (!detailsFilled.streetNumber) {
                await updateDoc(doc(db, "StaffData", user?.staffData?.id), {
                  "address.streetNumber": document.getElementById(
                    "detailsFilled_streetNumber"
                  ).value,
                });
              }
              if (!detailsFilled.streetName) {
                await updateDoc(doc(db, "StaffData", user?.staffData?.id), {
                  "address.streetName": document.getElementById(
                    "detailsFilled_streetName"
                  ).value,
                });
              }
              if (!detailsFilled.postcode) {
                await updateDoc(doc(db, "StaffData", user?.staffData?.id), {
                  "address.postcode": document.getElementById(
                    "detailsFilled_postcode"
                  ).value,
                });
              }
              if (!detailsFilled.suburb) {
                await updateDoc(doc(db, "StaffData", user?.staffData?.id), {
                  "address.suburb": document.getElementById(
                    "detailsFilled_suburb"
                  ).value,
                });
              }
              if (!detailsFilled.nextOfKin1Name) {
                const val = document.getElementById(
                  "detailsFilled_nextOfKin1Name"
                ).value;
                if (val) tmp.nextOfKin1Name = val;
              }
              if (!detailsFilled.nextOfKin1Phone) {
                const val = document.getElementById(
                  "detailsFilled_nextOfKin1Phone"
                ).value;
                if (val) tmp.nextOfKin1Phone = val;
              }
              if (!detailsFilled.taxFileNumber) {
                const val = document.getElementById(
                  "detailsFilled_taxFileNumber"
                ).value;
                if (val) tmp.taxFileNumber = val;
              }
              if (!detailsFilled.bankName) {
                const val = document.getElementById(
                  "detailsFilled_bankName"
                ).value;
                if (val) tmp.bankName = val;
              }
              if (!detailsFilled.BSB) {
                const val = document.getElementById("detailsFilled_BSB").value;
                if (val) tmp.BSB = val;
              }
              if (!detailsFilled.superannuationProvider) {
                const val = document.getElementById(
                  "detailsFilled_superannuationProvider"
                ).value;
                if (val) tmp.superannuationProvider = val;
              }
              if (!detailsFilled.superannuationMemberNumber) {
                const val = document.getElementById(
                  "detailsFilled_superannuationMemberNumber"
                ).value;
                if (val) tmp.superannuationMemberNumber = val;
              }
              if (!detailsFilled.superannuationFundUSI) {
                const val = document.getElementById(
                  "detailsFilled_superannuationFundUSI"
                ).value;
                if (val) tmp.superannuationFundUSI = val;
              }
              updateDoc(doc(db, "StaffData", user?.staffData?.id), { ...tmp });

              setDetailsFilledCorrectly(true);
            }}
          >
            Save
          </Button>
        </div>
      </Modal>
    </>
  );
};

function CreateListItem({ item, history, location, setOpen }) {
  return (
    <ListItem
      key={item.text}
      button
      onClick={() => {
        setOpen(false);
        setTimeout(() => {
          history.push(item.path);
        }, 200);
      }}
      className={parseIsActive(location, item)}
    >
      <ListItemIcon>{item.icon}</ListItemIcon>
      <ListItemText primary={item.text}></ListItemText>
    </ListItem>
  );
}

const parseIsActive = (location, item) => {
  if (location.pathname === item.path)
    return `background: "rgba(0, 0, 0, 0.2)"`;
  if (location.pathname === "/" && item.path === "/calendar")
    return `background: "rgba(0, 0, 0, 0.2)"`;
  return null;
};

const isAdmin = (user) => {
  if (user?.isSuperAdmin) return true;
  if (user?.isAdmin) return true;
  if (user?.staffData?.isSuperAdmin) return true;
  if (user?.staffData?.isAdmin) return true;
  return false;
};

const isEventTomorrow = (isoString) => {
  const jobTime = DateTime.fromISO(isoString).setZone("Australia/Sydney");
  const tomorrowStart = DateTime.now()
    .setZone("Australia/Sydney")
    .startOf("day")
    .plus({ days: 1 });

  const tomorrowEnd = DateTime.now()
    .setZone("Australia/Sydney")
    .endOf("day")
    .plus({ days: 1 });

  return (
    tomorrowStart.toSeconds() <= jobTime.toSeconds() &&
    jobTime.toSeconds() <= tomorrowEnd.toSeconds()
  );
};

const QRScannerDialog = ({ open, handleClose, generateLoginToken }) => {
  const containerStyle = {
    width: "80vw",
    maxWidth: 600,
    height: "70vh",
    maxHeight: 600,
    padding: 20,
    gap: 20,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  };

  function onScanSuccess(decodedText, decodedResult) {}

  function onScanFailure(error) {
    console.warn(`Code scan error = ${error}`);
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <div style={containerStyle}>
        <IconButton
          sx={{ position: "absolute", left: 10, top: 12 }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
        <span style={{ fontWeight: "bold" }}>SCAN LOGIN QR</span>
        <QRScanner
          fps={10}
          qrbox={250}
          disableFlip={false}
          qrCodeSuccessCallback={onScanSuccess}
          qrCodeErrorCallback={onScanFailure}
          handleClose={handleClose}
        />
      </div>
    </Dialog>
  );
};
